import React from "react";
import { Row, Col } from "react-bootstrap";
import EventActivityVisual from "../EventActivityVisual/EventActivityVisual";
import EventActivityDetails from "../EventActivityDetails/EventActivityDetails";
import EventActivityPricing from "../EventActivityPricing/EventActivityPricing";
import "./EventActivityCard.scss";

const EventActivityCard = ({
  id,
  imageUrl,
  title,
  status,
  date,
  duration,
  person,
  price,
  currency,
}) => {
  return (
    <div className="event-activity-card">
      <Row className="no-gutters">
        <Col md={3} className="event-activity-card__visual">
          <EventActivityVisual imageUrl={imageUrl} />
        </Col>
        <Col md={6} className="event-activity-card__details">
          <EventActivityDetails
            title={title}
            status={status}
            date={date}
            duration={duration}
            person={person}
            price={price}
          />
        </Col>
        <Col md={3} className="event-activity-card__pricing">
          <EventActivityPricing price={price} currency={currency} />
        </Col>
      </Row>
    </div>
  );
};

export default EventActivityCard;
